import { LoadablePaint } from '@confluence/loadable';

export const EmbedRouteLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-EmbedContainer" */ './EmbedContainer'))
			.EmbedContainer,
});
